export const apiFetch = $fetch.create({
  async onRequest(ctx) {
    if (import.meta.server) {
      const headers = useRequestHeaders(['cf-connecting-ip', 'x-forwarded-for', 'user-agent'])
      ctx.options.headers = { ...ctx.options.headers, ...headers }
    }
  },
})
